import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { AccountTitleInterface } from '../../../interfaces/AccountTitle.interface';
import { detectDeviceType, formatAmount } from '../../../utils/helpers';
import { getAccountDetailsContent } from '../../../store/contentSlice';

const AccountTitle = ({
  portfolioLogo,
  displayName,
  last4Accountnumber,
  availableCredit,
  portfolio,
  isAccordionCollapsed,
  isPended,
  headerRef,
  handleOnClick,
}: AccountTitleInterface): ReactElement => {
  const { availableToSpendText, usDollarSymbol, portfolioLogoAltText }: any =
    useSelector(getAccountDetailsContent);
  const cssIsPendedTitle = isPended && 'mt-3';

  return (
    <>
      <div
        className="accordion-title accordion-header-wrapper"
        ref={headerRef}
        data-card-open={isAccordionCollapsed}
        data-type={detectDeviceType}
        data-reason={`dropdown:${displayName}`}
        data-object="button"
        onClick={handleOnClick}
        data-testid="accordion-header-wrapper"
      >
        <div className="card-logo-img-wrapper">
          <img
            src={portfolioLogo}
            alt={`${portfolio} ${portfolioLogoAltText}`}
            loading="lazy"
            className="client-card-image"
            data-testid="img-account-title-client-logo"
          />
        </div>
        <div className="account-title-divider-wrapper">
          <span className="account-title-divider"></span>
        </div>
        <div className="account-title-details-wrapper">
          <div className="card-title-wrapper">
            <div
              className={`accordian-title-ellipsis ${cssIsPendedTitle}`}
              data-testid="account-title-client-name"
            >
              {displayName}
            </div>
            {!isPended && (
              <span
                className="last-four-digit-account-no"
                data-testid="account-title-account-number"
              >
                *{last4Accountnumber}
              </span>
            )}
          </div>
          {!isPended && (
            <div
              className="available-credit"
              data-testid="account-title-available-credit"
            >
              {usDollarSymbol}
              {formatAmount(availableCredit)} {availableToSpendText}
            </div>
          )}
        </div>
        <div className="arrow" data-testid="account-title-accordion-caret">
          <FontAwesomeIcon
            icon={isAccordionCollapsed ? faAngleDown : faAngleUp}
            className="arrow-down-up"
          />
        </div>
      </div>
    </>
  );
};

export default AccountTitle;
